export const videoConstraints = {
  width: 1920,
  height: 1080,
  facingMode: 'environment'
}
